module.exports = __webpack_public_path__ + "static/media/select-white.914559aa.svg";